export default __webpack_public_path__ + "static/media/offer-nutrition.6dff526a.jpg";